import type { ReactNode } from "react";

import type { StackProps } from "@mui/material/Stack";
import Stack from "@mui/material/Stack";

type Props = {
  children: ReactNode;
} & StackProps;
export const HStack = ({ children, ...rest }: Props) => {
  return (
    <Stack direction={"row"} {...rest}>
      {children}
    </Stack>
  );
};
